import { UiCommands } from './UiCommands';

export function changeWorkCenterFilterCommand(
  this: UiCommands,
  filter: string | null
): void {
  let newFilter = filter;

  // if the filter is being set to empty or blank spaces, set filter to null
  // null filter indicates no filter exists
  if (filter != null && filter.trim() === '') {
    newFilter = null;
  }

  this.uiState.workCenterFilter = newFilter;
  this.setUiStateTriggerReRender(this.uiState);
}
